var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0077 13.4346C20.0999 11.6032 23.4947 11.6032 25.5869 13.4346C27.681 15.2659 27.681 18.2355 25.5869 20.0669C25.2242 20.3867 24.8187 20.6493 24.3898 20.8566C23.0587 21.5016 21.7991 22.6415 21.7991 24.1209V25.461M37.8778 21.4409C37.8778 23.5526 37.4619 25.6436 36.6538 27.5946C35.8456 29.5456 34.6612 31.3183 33.1679 32.8115C31.6747 34.3047 29.902 35.4892 27.9511 36.2973C26.0001 37.1054 23.909 37.5214 21.7973 37.5214C19.6856 37.5214 17.5945 37.1054 15.6436 36.2973C13.6926 35.4892 11.9199 34.3047 10.4267 32.8115C8.93346 31.3183 7.74897 29.5456 6.94085 27.5946C6.13273 25.6436 5.7168 23.5526 5.7168 21.4409C5.7168 17.176 7.41099 13.0859 10.4267 10.0702C13.4423 7.05454 17.5325 5.36035 21.7973 5.36035C26.0621 5.36035 30.1523 7.05454 33.1679 10.0702C36.1836 13.0859 37.8778 17.176 37.8778 21.4409ZM21.7973 30.8212H21.8116V30.8355H21.7973V30.8212Z",
    stroke: "white",
    strokeWidth: 1.00056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.c4ea7dc98f757f1224d74d4d96d18da6.svg";
export { ForwardRef as ReactComponent };